<template>
  <div class="vomiting">

    <div class="head-links">
      <router-link class="back-links" to="/algorithms">Алгоритми діагностики</router-link>
      <span>/</span>
      <router-link class="now-page" to="/algorithms/fg">
        Недостатність харчування
      </router-link>
    </div>

    <div class="content-wrapper">

      <div class="chose-next-step">

        <div class="h2-title">
          <div @click="$router.go(-1)" class="back-arrow">
            <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.53552 1.52856L1.00004 5.81836" stroke="#00ACE6" stroke-width="2"
                    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M1.00004 5.81897L5.53552 10.1055" stroke="#00ACE6" stroke-width="2"
                    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="middle-text">
            <p>Огляд пацієнта</p>
          </div>
          <div @click="openliteraturePopup()" class="popup-info-icon">
            <svg width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="7.5" cy="8.5" r="7" fill="#00ACE6" stroke="#00ACE6"/>
              <path
                  d="M6.61719 10.1582V9.72461C6.61719 9.34961 6.69727 9.02344 6.85742 8.74609C7.01758 8.46875 7.31055 8.17383 7.73633 7.86133C8.14648 7.56836 8.41602 7.33008 8.54492 7.14648C8.67773 6.96289 8.74414 6.75781 8.74414 6.53125C8.74414 6.27734 8.65039 6.08398 8.46289 5.95117C8.27539 5.81836 8.01367 5.75195 7.67773 5.75195C7.0918 5.75195 6.42383 5.94336 5.67383 6.32617L5.03516 5.04297C5.90625 4.55469 6.83008 4.31055 7.80664 4.31055C8.61133 4.31055 9.25 4.50391 9.72266 4.89062C10.1992 5.27734 10.4375 5.79297 10.4375 6.4375C10.4375 6.86719 10.3398 7.23828 10.1445 7.55078C9.94922 7.86328 9.57812 8.21484 9.03125 8.60547C8.65625 8.88281 8.41797 9.09375 8.31641 9.23828C8.21875 9.38281 8.16992 9.57227 8.16992 9.80664V10.1582H6.61719ZM6.42969 12.1621C6.42969 11.834 6.51758 11.5859 6.69336 11.418C6.86914 11.25 7.125 11.166 7.46094 11.166C7.78516 11.166 8.03516 11.252 8.21094 11.4238C8.39062 11.5957 8.48047 11.8418 8.48047 12.1621C8.48047 12.4707 8.39062 12.7148 8.21094 12.8945C8.03125 13.0703 7.78125 13.1582 7.46094 13.1582C7.13281 13.1582 6.87891 13.0723 6.69922 12.9004C6.51953 12.7246 6.42969 12.4785 6.42969 12.1621Z"
                  fill="white"/>
            </svg>
          </div>
        </div>

        <div class="chose-wrapper">
          <router-link class="btn-first-consultation item-link" to="/algorithms/fg/diagnostics">
            <div class="item">
              <div class="icon">
                <svg width="29" height="41" viewBox="0 0 29 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M27.1429 4.81055H22.4768C22.1036 3.74315 21.0953 2.97621 19.9128 2.97621H17.8458C17.7417 2.15375 17.3445 1.39786 16.7286 0.850029C16.1127 0.302201 15.3204 0 14.5 0C13.6796 0 12.8873 0.302201 12.2714 0.850029C11.6555 1.39786 11.2583 2.15375 11.1542 2.97621H9.08717C7.90468 2.97621 6.8964 3.74315 6.52323 4.81055H1.85709C1.36472 4.8111 0.892682 5.00901 0.544529 5.36087C0.196376 5.71273 0.000545202 6.18979 0 6.68739V39.1232C0.000545202 39.6208 0.196376 40.0978 0.544529 40.4497C0.892682 40.8015 1.36472 40.9994 1.85709 41H27.1429C27.6353 40.9994 28.1073 40.8015 28.4555 40.4497C28.8036 40.0978 28.9995 39.6208 29 39.1232V6.68739C28.9995 6.18979 28.8036 5.71273 28.4555 5.36087C28.1073 5.00901 27.6353 4.8111 27.1429 4.81055ZM7.26751 4.81055C7.43591 4.46831 7.69539 4.18029 8.01679 3.97884C8.33819 3.77739 8.7088 3.67048 9.087 3.67011H11.8051L11.8144 3.3327C11.8545 1.85312 13.0339 0.694124 14.4993 0.694124C15.9647 0.694124 17.1441 1.85312 17.1843 3.3327L17.1935 3.67011H19.9121C20.4134 3.6704 20.8969 3.85781 21.2698 4.19637C21.6427 4.53494 21.8787 5.00078 21.9325 5.50445C21.9401 5.57723 21.9439 5.65037 21.944 5.72355V7.69095C21.9437 7.92166 21.853 8.14286 21.6915 8.30599C21.5301 8.46913 21.3112 8.56088 21.083 8.56111H7.91566C7.68738 8.56088 7.46851 8.46913 7.30709 8.30599C7.14567 8.14286 7.05489 7.92166 7.05466 7.69095V5.72355C7.05468 5.65037 7.05852 5.57723 7.06616 5.50445C7.09185 5.26288 7.16003 5.02788 7.26751 4.81055ZM7.91635 9.25502H21.0837C21.494 9.2546 21.8874 9.08968 22.1775 8.79646C22.4677 8.50323 22.6308 8.10564 22.6313 7.69095V7.10113H25.1954C25.5751 7.10154 25.9392 7.25418 26.2077 7.52555C26.4762 7.79691 26.6272 8.16485 26.6276 8.54862V37.2614C26.6272 37.6451 26.4761 38.013 26.2076 38.2844C25.9391 38.5557 25.5751 38.7083 25.1954 38.7087H3.80463C3.42493 38.7083 3.0609 38.5557 2.79239 38.2844C2.52388 38.013 2.37283 37.6451 2.37238 37.2614V8.54931C2.37279 8.16554 2.52382 7.79761 2.79233 7.52624C3.06084 7.25488 3.4249 7.10224 3.80463 7.10183H6.36875V7.69165C6.36934 8.10621 6.5326 8.50362 6.82272 8.7967C7.11284 9.08978 7.50614 9.2546 7.91635 9.25502ZM28.3134 39.1232C28.313 39.4368 28.1896 39.7374 27.9702 39.9592C27.7507 40.181 27.4532 40.3057 27.1429 40.3061H1.85709C1.54676 40.3057 1.24926 40.181 1.02983 39.9592C0.8104 39.7374 0.686965 39.4368 0.686602 39.1232V6.68739C0.686965 6.37377 0.8104 6.0731 1.02983 5.85133C1.24926 5.62957 1.54676 5.50482 1.85709 5.50445H6.37733C6.37172 5.57685 6.36886 5.64988 6.36875 5.72355V6.40792H3.80463C3.24289 6.40861 2.70434 6.63444 2.30713 7.03588C1.90991 7.43732 1.68646 7.98159 1.68578 8.54931V37.2614C1.68646 37.8291 1.90992 38.3734 2.30714 38.7748C2.70436 39.1762 3.2429 39.402 3.80463 39.4026H25.1954C25.7571 39.402 26.2957 39.1763 26.6929 38.7748C27.0901 38.3734 27.3136 37.8291 27.3142 37.2614V8.54931C27.3136 7.98158 27.0901 7.43728 26.6929 7.03583C26.2957 6.63438 25.7571 6.40856 25.1954 6.40792H22.6313V5.72355C22.6313 5.64988 22.6284 5.57685 22.6227 5.50445H27.1429C27.4532 5.50482 27.7507 5.62957 27.9702 5.85133C28.1896 6.0731 28.313 6.37377 28.3134 6.68739V39.1232ZM13.4964 2.99477C13.4963 2.79415 13.5552 2.59802 13.6654 2.4312C13.7757 2.26437 13.9324 2.13434 14.1158 2.05754C14.2992 1.98074 14.501 1.96063 14.6957 1.99975C14.8904 2.03887 15.0692 2.13546 15.2096 2.2773C15.35 2.41915 15.4456 2.59989 15.4843 2.79665C15.5231 2.99341 15.5032 3.19737 15.4273 3.38272C15.3513 3.56807 15.2227 3.7265 15.0576 3.83796C14.8926 3.94942 14.6985 4.00891 14.5 4.00891C14.2338 4.00891 13.9786 3.90207 13.7904 3.71189C13.6022 3.5217 13.4964 3.26375 13.4964 2.99477ZM8.02071 22.5584C8.64983 22.5575 9.26395 22.7524 9.77961 23.1167L9.34654 23.6574C8.9543 23.3923 8.49292 23.251 8.02105 23.2516C6.70158 23.2516 5.62807 24.3365 5.62807 25.6701C5.62807 27.0036 6.70158 28.0887 8.02105 28.0887C9.34053 28.0887 10.4147 27.0043 10.4147 25.6708C10.415 25.3565 10.3544 25.0452 10.2362 24.7544L10.7124 24.1582C10.968 24.6204 11.1019 25.1412 11.1013 25.6708C11.1013 27.387 9.71971 28.7833 8.02157 28.7833C6.32343 28.7833 4.94199 27.387 4.94199 25.6708C4.94199 23.9545 6.32309 22.5584 8.02105 22.5584H8.02071ZM10.6526 23.1267C10.6877 23.1553 10.7169 23.1907 10.7385 23.2307C10.7601 23.2707 10.7736 23.3146 10.7784 23.3599C10.7832 23.4052 10.7791 23.4511 10.7663 23.4948C10.7536 23.5385 10.7325 23.5793 10.7041 23.6147L8.04217 26.9486L6.58314 25.1869C6.52468 25.1164 6.49636 25.0252 6.50439 24.9336C6.51242 24.8419 6.55615 24.7572 6.62596 24.6982C6.69578 24.6391 6.78595 24.6104 6.87665 24.6186C6.96734 24.6267 7.05114 24.6709 7.10959 24.7414L8.03255 25.8558L10.1698 23.1789C10.1981 23.1434 10.233 23.1139 10.2727 23.092C10.3123 23.0702 10.3558 23.0564 10.4007 23.0516C10.4455 23.0467 10.4909 23.0508 10.5342 23.0637C10.5775 23.0766 10.6179 23.098 10.653 23.1267H10.6526ZM13.5384 23.8987H23.7149C23.8059 23.8987 23.8933 23.9352 23.9576 24.0003C24.022 24.0654 24.0582 24.1536 24.0582 24.2456C24.0582 24.3377 24.022 24.4259 23.9576 24.491C23.8933 24.556 23.8059 24.5926 23.7149 24.5926H13.5388C13.4477 24.5926 13.3604 24.556 13.296 24.491C13.2316 24.4259 13.1955 24.3377 13.1955 24.2456C13.1955 24.1536 13.2316 24.0654 13.296 24.0003C13.3604 23.9352 13.4477 23.8987 13.5388 23.8987H13.5384ZM24.0582 27.096C24.0582 27.188 24.022 27.2763 23.9576 27.3414C23.8933 27.4064 23.8059 27.443 23.7149 27.443H13.5388C13.4477 27.443 13.3604 27.4064 13.296 27.3414C13.2316 27.2763 13.1955 27.188 13.1955 27.096C13.1955 27.004 13.2316 26.9158 13.296 26.8507C13.3604 26.7856 13.4477 26.7491 13.5388 26.7491H23.7152C23.8063 26.7491 23.8936 26.7856 23.958 26.8507C24.0224 26.9158 24.0585 27.004 24.0585 27.096H24.0582ZM10.7115 31.9969C10.9671 32.4591 11.101 32.9799 11.1005 33.5095C11.1005 35.2257 9.71885 36.6218 8.02071 36.6218C6.32257 36.6218 4.94113 35.2257 4.94113 33.5095C4.94113 31.7933 6.32274 30.3971 8.02071 30.3971C8.64984 30.3961 9.26399 30.5911 9.77961 30.9554L9.34723 31.4968C8.95499 31.2317 8.49361 31.0904 8.02174 31.091C6.70226 31.091 5.62876 32.1759 5.62876 33.5095C5.62876 34.843 6.70226 35.9279 8.02174 35.9279C9.34122 35.9279 10.4147 34.843 10.4147 33.5095C10.415 33.1952 10.3544 32.8839 10.2362 32.5932L10.7115 31.9969ZM8.03273 33.6944L10.1699 31.0176C10.2271 30.946 10.3101 30.9003 10.4006 30.8905C10.4912 30.8808 10.5819 30.9077 10.6527 30.9655C10.7236 31.0233 10.7688 31.1072 10.7785 31.1987C10.7882 31.2902 10.7615 31.3818 10.7043 31.4534L8.04234 34.7873L6.58331 33.0256C6.55437 32.9907 6.53252 32.9503 6.519 32.9069C6.50549 32.8634 6.50058 32.8177 6.50456 32.7723C6.50854 32.7269 6.52132 32.6827 6.54218 32.6424C6.56304 32.602 6.59157 32.5661 6.62614 32.5369C6.6607 32.5076 6.70063 32.4855 6.74365 32.4719C6.78666 32.4582 6.83191 32.4533 6.87682 32.4573C6.92173 32.4613 6.96541 32.4742 7.00538 32.4953C7.04535 32.5164 7.08082 32.5452 7.10976 32.5801L8.03273 33.6944ZM24.0582 32.0842C24.0582 32.1762 24.022 32.2644 23.9576 32.3295C23.8933 32.3946 23.8059 32.4311 23.7149 32.4311H13.5388C13.4477 32.4311 13.3604 32.3946 13.296 32.3295C13.2316 32.2644 13.1955 32.1762 13.1955 32.0842C13.1955 31.9922 13.2316 31.9039 13.296 31.8388C13.3604 31.7738 13.4477 31.7372 13.5388 31.7372H23.7152C23.8063 31.7372 23.8936 31.7738 23.958 31.8388C24.0224 31.9039 24.0585 31.9922 24.0585 32.0842H24.0582ZM24.0582 34.9347C24.0582 35.0268 24.022 35.115 23.9576 35.1801C23.8933 35.2451 23.8059 35.2817 23.7149 35.2817H13.5388C13.4477 35.2817 13.3604 35.2451 13.296 35.1801C13.2316 35.115 13.1955 35.0268 13.1955 34.9347C13.1955 34.8427 13.2316 34.7545 13.296 34.6894C13.3604 34.6243 13.4477 34.5878 13.5388 34.5878H23.7152C23.8063 34.5878 23.8936 34.6243 23.958 34.6894C24.0224 34.7545 24.0585 34.8427 24.0585 34.9347H24.0582ZM12.7562 20.8991H16.2438V17.7385H19.3704V14.2137H16.2438V11.0538H12.7562V14.2137H9.62959V17.7385H12.7562V20.8991ZM10.3162 17.0453V14.9076H13.4428V11.7477H15.5572V14.9076H18.6838V17.0446H15.5572V20.2052H13.4428V17.0446L10.3162 17.0453Z"
                      fill="#1E3B89"/>
                </svg>
                <div class="text">
                  Діагностика
                </div>
              </div>

              <div class="arrow">
                <svg width="25" height="26" viewBox="0 0 25 26" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12.5" cy="13.4023" r="12" transform="rotate(-90 12.5 13.4023)"
                          stroke="#D1DDE9"/>
                  <path d="M11 8.87989L15.5355 13.3926" stroke="#00ACE6" stroke-width="2"
                        stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M15.5355 13.3931L11 17.9023" stroke="#00ACE6" stroke-width="2"
                        stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>

              </div>
            </div>
          </router-link>

          <router-link class="btn-second-visit item-link" to="/algorithms/fg/calcDayNorm">
            <div class="item">
              <div class="icon">
                <svg width="31" height="40" viewBox="0 0 31 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M19.272 33.4971H25.8136M2.18636 1H28.5521C28.8678 0.999986 29.1708 1.12465 29.395 1.34682C29.6192 1.56899 29.7467 1.8707 29.7496 2.18636V37.7436C29.7467 38.0593 29.6192 38.361 29.395 38.5832C29.1708 38.8053 28.8678 38.93 28.5521 38.93H2.18636C1.87261 38.9271 1.57254 38.8012 1.35068 38.5793C1.12882 38.3575 1.00289 38.0574 1 37.7436V2.18636C1 1.87172 1.12494 1.56998 1.34743 1.3475C1.56991 1.12501 1.87172 1 2.18636 1V1ZM8.17351 14.061V20.6025V14.061ZM4.84729 17.2763H11.4H4.84729ZM24.5607 14.9813L19.9372 19.6047L24.5607 14.9813ZM5.81189 29.417L10.4353 34.0515L5.81189 29.417ZM5.81189 34.0515L10.4353 29.417L5.81189 34.0515ZM1.09975 24.3057H29.5944H1.09975ZM15.3581 10.0806V38.542V10.0806ZM19.272 29.9714H25.8136H19.272Z"
                      stroke="#1E3B89" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M19.4384 14.2716C19.3276 14.3814 19.252 14.5216 19.2211 14.6745C19.1902 14.8274 19.2054 14.986 19.2648 15.1302C19.3242 15.2744 19.4251 15.3977 19.5547 15.4845C19.6843 15.5713 19.8368 15.6176 19.9927 15.6176C20.1487 15.6176 20.3011 15.5713 20.4307 15.4845C20.5603 15.3977 20.6612 15.2744 20.7206 15.1302C20.78 14.986 20.7952 14.8274 20.7643 14.6745C20.7334 14.5216 20.6578 14.3814 20.5471 14.2716C20.4748 14.1978 20.3885 14.1392 20.2933 14.0992C20.1981 14.0592 20.096 14.0386 19.9927 14.0386C19.8895 14.0386 19.7873 14.0592 19.6921 14.0992C19.5969 14.1392 19.5106 14.1978 19.4384 14.2716Z"
                        stroke="#1E3B89" stroke-width="0.8" stroke-miterlimit="22.93"/>
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M24.3279 19.1613C24.1842 19.3101 24.104 19.5088 24.104 19.7157C24.104 19.9225 24.1842 20.1212 24.3279 20.27C24.4377 20.3808 24.578 20.4564 24.7309 20.4873C24.8837 20.5182 25.0423 20.5029 25.1866 20.4435C25.3308 20.3841 25.4541 20.2833 25.5409 20.1537C25.6277 20.0241 25.674 19.8716 25.674 19.7157C25.674 19.5597 25.6277 19.4073 25.5409 19.2777C25.4541 19.1481 25.3308 19.0472 25.1866 18.9878C25.0423 18.9284 24.8837 18.9132 24.7309 18.9441C24.578 18.975 24.4377 19.0506 24.3279 19.1613V19.1613Z"
                        stroke="#1E3B89" stroke-width="0.8" stroke-miterlimit="22.93"/>
                  <path d="M1.28824 10.136H29.7496" stroke="#1E3B89" stroke-width="0.8" stroke-linecap="round"
                        stroke-linejoin="round"/>
                </svg>
                <div class="text">
                  Розрахунок добової норми
                </div>
              </div>
              <div class="arrow">
                <svg width="25" height="26" viewBox="0 0 25 26" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12.5" cy="13.4023" r="12" transform="rotate(-90 12.5 13.4023)"
                          stroke="#D1DDE9"/>
                  <path d="M11 8.87989L15.5355 13.3926" stroke="#00ACE6" stroke-width="2"
                        stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M15.5355 13.3931L11 17.9023" stroke="#00ACE6" stroke-width="2"
                        stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>

              </div>
            </div>
          </router-link>
        </div>

      </div>

    </div>

    <transition name="fade">
      <div class="literature-popup" v-if="literaturePopup === true">
        <div class="literature-popup-content">
          <div class="close-header">
            <p class="h3-title">Література</p>
            <div @click="closeliteraturePopup()" class="close-btn">
              <svg width="19" height="19" viewBox="0 0 19 19" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path d="M0.258301 0.257812L18.7418 18.7413" stroke="#00ACE6" stroke-width="1.7"
                      stroke-miterlimit="10"/>
                <path d="M18.7418 0.257812L0.258301 18.7413" stroke="#00ACE6" stroke-width="1.7"
                      stroke-miterlimit="10"/>
              </svg>
            </div>
          </div>
          <div class="text-block">
            <p class="list-text" style="margin-bottom: 15px">
              <span>1. </span>
              <a href="https://hcp.nutricia.ua/library-item/article/52">Добрянський Д.О. Недостатність харчування й
                сповільнений фізичний розвиток у ранньому дитинстві: сучасні визначення, класифікація, харчова
                профілактика й корекція / Д.О. Добрянський // Здоров’я дитини. – 2020. – Т. 15, №7-8. – С. 55-67.</a>
            </p>

            <p class="list-text">
              <span>2. </span>
              <a href="https://apps.who.int/iris/handle/10665/43411">Protein and amino acid requirements in human
                nutrition : report of a Joint FAO/WHO/UNU expert consultation. Geneva : World Health Organization, 2007.
                – 265 p. – (WHO technical report series №935).</a>
            </p>

            <p class="list-text">
              <span>3. </span>
              <a href="https://journals.lww.com/jpgn/Fulltext/2005/11002/2__Energy.2.aspx">Guidelines on paediatric
                parenteral nutrition of the ESPGHAN and the ESPEN, supported by the ESPR / [Berthold Koletzko, Olivier
                Goulet, Joanne Hunt et al.] // Journal of Pediatric Gastroenterology and Nutrition. – 2005. – Vol. 41,
                Suppl. 2. – P. S5-S11.</a>
            </p>

            <p class="list-text">
              <span>4. </span>
              Gastroenterologia dziecięca : poradnik lekarza praktyka / [pod redakcją dr hab. n med. Piotra Albrechta].
              – Lublin : Wydawnictwo Czelej, 2014. – 432 str.​
            </p>

            <p class="list-text">
              <span>5. </span>
              <a href="https://www.mdpi.com/2072-6643/13/9/3094">Yi D.Y. Human breast milk composition and function in
                human health: from nutritional components to microbiome and microRNAs / Dae Yong Yi, Su Yeong Kim //
                Nutrients. – 2021. – №13 (9). – 11 p.</a>
            </p>
          </div>

        </div>
      </div>
    </transition>

  </div>

</template>

<script>
export default {
  name: "vomiting",
  data: () => ({
    literaturePopup: false,
  }),

  methods: {

    openliteraturePopup() {
      document.getElementsByTagName("body")[0].style.overflow = "hidden";
      this.literaturePopup = true;
    },
    closeliteraturePopup() {
      document.getElementsByTagName("body")[0].style.overflow = "visible";
      this.literaturePopup = false;
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/vars";

.vomiting {


  .components_send-question-block, .section-nav {
    display: none;
  }

  .head-links {
    background-color: rgba(255, 255, 255, 0.49);
    width: 100%;
    padding: 10px 15px;

    .back-links {
      color: #7392B1;
      font-family: $fontR;
      font-size: 11px;
    }

    span {
      padding: 0 5px;
      color: #7392B1;
      font-family: $fontR;
      font-size: 11px;
    }

    .now-page {
      color: #00ACE6;
      font-family: $fontSB;
      font-size: 11px;
    }
  }


  .content-wrapper {
    padding: 25px 15px 0 15px;
    margin-bottom: 80px;

    .chose-next-step {
      background: white;

      .h2-title {
        border-bottom: 1px solid #DAE3ED;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .popup-info-icon {
          display: flex;
          align-items: center;
          cursor: pointer;
        }

        .back-arrow {
          cursor: pointer;
        }

        .middle-text {
          p {
            color: #9AB9D8;
            font-family: $fontB;
            font-size: 12px;
            text-transform: uppercase;
            letter-spacing: 2px;
          }
        }

        padding: 10px;
      }

      .chose-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: center;

        a {
          display: flex;
          width: 50%;

          &:first-child {
            .item {
              border-right: 1px solid #DAE3ED;
            }
          }

        }

        .item {

          padding: 25px 0;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-direction: column;
          transition: all 0.2s ease;

          .icon {
            display: flex;
            flex-direction: column;
            align-items: center;
          }

          svg {
            path, circle {
              transition: all 0.2s ease;
            }
          }

          &:active {
            background: #E0ECF7;

            .arrow {

              path {
                stroke: white;
              }
            }

            svg {


              circle {
                fill: #00ACE6;
              }
            }
          }

          .text {
            text-align: center;
            color: #1E3B89;
            font-size: 15px;
            font-family: $fontR;
            margin: 10px 0;
          }

        }
      }
    }
  }

  .literature-popup {
    padding: 15px;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    background: rgba(88, 101, 136, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;

    max-width: 425px;
    margin: 0 auto;
    right: 0;

    .literature-popup-content {
      margin-top: 15%;
      height: fit-content;
      background: #FFFFFF;
      border-radius: 4px;

      .close-header {
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 15px;
        background: #EEF3F8;
        border-radius: 4px 4px 0 0;

        .h3-title {
          font-family: $fontB;
          font-size: 12px;
          line-height: 16px;

          letter-spacing: 0.11em;
          text-transform: uppercase;

          color: #9AB9D8;
        }

      }

      .text-block {
        padding: 15px;
        overflow-y: auto;
        max-height: 70vh;

        .list-text {
          color: #1E3B89;
          font-size: 15px;
          font-family: $fontL;

          margin-bottom: 15px;

          a {
            color: #00ACE6;
            text-decoration: underline;
          }

          span {
            font-family: $fontSB;
          }
        }
      }
    }
  }
}

</style>
